/** True if token is structurally bad or its exp ≤ now. */
function isTokenExpired(token) {
    try {
        const payload = decodeJwt(token);
        return Date.now() / 1000 >= payload.exp;
    }
    catch {
        return true; // treat malformed token as expired
    }
}
/* ------------------------------------------------------------------ */
/*  internals                                                         */
/* ------------------------------------------------------------------ */
function decodeJwt(token) {
    const [header, payload, signature] = token.split(".");
    if (!header || !payload || !signature) {
        throw new Error("Malformed JWT");
    }
    // Handle URL-safe Base64
    let b64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    // Add padding if necessary
    b64 = b64.padEnd(Math.ceil(b64.length / 4) * 4, "=");
    const jsonText = atob(b64);
    return JSON.parse(jsonText);
}

export { decodeJwt, isTokenExpired };
//# sourceMappingURL=jwt_core.js.map
